import { render, staticRenderFns } from "./EmailNotifications.vue?vue&type=template&id=525bae92&scoped=true&"
import script from "./EmailNotifications.vue?vue&type=script&lang=js&"
export * from "./EmailNotifications.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotifications.vue?vue&type=style&index=0&id=525bae92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525bae92",
  null
  
)

export default component.exports